import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const DocsAndDataParent = lazy(() => import("./DocsAndDataParent"));

const DOCSANDDATA_ROUTES: RouteObject[] = [
  {
    path: "/private/documents",
    element: React.createElement(DocsAndDataParent),
  },
];

export default DOCSANDDATA_ROUTES;
